export const NAME = 'DrobneSluzby';
